import { Store, StoreWriteModel } from "../../../models/Store";

export interface UpsertStoreState {
  showDialog: boolean;
  newStore: boolean;
  store: StoreWriteModel;
}

export enum ActionStatuses {
  STOP_ALARM_SUCCESS = 1,
  STOP_ALARM_ERROR,
  UPDATE_PRICETAGS_SUCCESS,
  UPDATE_PRICETAGS_ERROR,
  UPSERT_STORE_SUCCESS,
  UPSERT_STORE_ERROR,
  OPEN_DOOR_SUCCESS,
  OPEN_DOOR_ERROR
}
